import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceActivity', ['cachedActivities', 'selectedActivity']),
}

export const Methods = mapActions('deviceActivity', [
  'fetchActivities',
  'selectActivity',
  'updateActivity',
])
